import Vue from 'vue';
import Vuex from 'vuex';

import accountModule from './account';

Vue.use(Vuex);

// collect our various store modules and export them as store.
const store = new Vuex.Store({
    modules: {
        account: accountModule
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js